const form = {
  formId: "new-user-form",
  formField: {
    documentNumber: {
      name: "documentNumber",
      label: "Số giấy đề nghị hoàn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn số giấy đề nghị hoàn",
    },
    whyRefund: {
      name: "whyRefund",
      label: "Lý do đề nghị hoàn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn lý do đề nghị hoàn",
    },
    sendTo: {
      name: "sendTo",
      label: "Kính gửi:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn nơi gửi",
    },
    taxPayers: {
      name: "taxpayers",
      label: "[01] Người nộp thuế:",
      type: "text",
      placeholder: "Người nộp thuế",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxCode: {
      name: "taxCode",
      label: "[02] Mã số thuế:",
      type: "text",
      placeholder: "Mã số thuế",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "[03] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "Đại lý thuế",
      errorMsg: "Vui lòng nhập tên đại lý thuế",
    },
    taxAgentCode: {
      name: "taxAgentCode",
      label: "[04] Mã số thuế đại lý:",
      type: "text",
      placeholder: "Mã số thuế đại lý",
      errorMsg: "Vui lòng nhập mã số thuế đại lý",
    },
    accountOwner: {
      name: "accountOwner",
      label: "Chủ tài khoản:",
      type: "text",
      errorMsg: "Vui lòng nhập Chủ tài khoản",
    },
    bankAccountNumber: {
      name: "bankAccountNumber",
      label: "số tài khoản:",
      type: "text",
      errorMsg: "Vui lòng nhập số tài khoản",
    },
    bankAccountNumber: {
      name: "bankAccountNumber",
      label: "số tài khoản:",
      type: "text",
      errorMsg: "Vui lòng nhập số tài khoản",
    },
    bankName: {
      name: "bankName",
      label: "Tên ngân hàng:",
      type: "text",
      errorMsg: "Vui lòng nhập tên ngân hàng",
    },
    attachDocument: {
      name: "attachDocument",
      label: "IV - tài liệu gởi kèm: (ghi rõ tên tài liệu, bản chính, bản sao)",
      type: "text",
      errorMsg: "Vui lòng nhập tài liệu gởi kèm",
    },
    chiefAccountant: {
      name: "chiefAccountant",
      label: "Họ và tên:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên nhân viên đại lý thuế",
    },
    certificateNumber: {
      name: "certificateNumber",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số chứng chỉ hành nghề",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

const AppendixForm = {
  formIdAppendix: "new-user-form",
  formFieldAppendix: {
    from: {
      name: "from",
      label: "Từ kỳ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập kỳ",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    to: {
      name: "to",
      label: "Đến kỳ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập kỳ",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    payerNameAppendix: {
      name: "payerNameAppendix",
      label: "[02].Tên người nộp thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxIdAppendix: {
      name: "taxId",
      label: "[03].Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgentNameAppendix: {
      name: "taxAgentName",
      label: "[04] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "Đại lý thuế",
      errorMsg: "Vui lòng nhập tên đại lý thuế",
    },
    taxAgentCodeAppendix: {
      name: "taxAgentCode",
      label: "[05]Mã số thuế đại lý:",
      type: "text",
      placeholder: "Mã số thuế đại lý",
      errorMsg: "Vui lòng nhập mã số thuế đại lý",
    },
  },
};

export { form, AppendixForm };
